import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { SalatiToneDetailsDto, SalatiToneDetailsDtoImpl } from './salatitonedetailsdto';

export class SalatiToneDetailsBuilder
 {
    constructor(private salatiToneDetailsResponse: any) 
    {
        if(salatiToneDetailsResponse === undefined)
        {
            throw new NoDataException("Salati ToneDetails doesnt exists");
        }
    }

    buildAll(): SalatiToneDetailsDto {
        return this.parseSalatiToneDetailsResponse();
    }

    private parseSalatiToneDetailsResponse(): SalatiToneDetailsDto {
        
        let salatiStatusDto = null;
        salatiStatusDto = new SalatiToneDetailsDtoImpl();
        salatiStatusDto.setServiceName(this.salatiToneDetailsResponse.serviceName);
        salatiStatusDto.setToneId(this.salatiToneDetailsResponse.toneId);
        salatiStatusDto.setToneName(this.salatiToneDetailsResponse.toneName);
        salatiStatusDto.setTonePath(this.salatiToneDetailsResponse.tonePath);
            
        return salatiStatusDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/salatitonedetails/salatitonedetailsbuilder.ts